import PropTypes from 'prop-types';
import styles from './FJPhotoRemoveBgCustomLeft.module.less';
import FJImageInputTwo from '../../../../common/components/FJImageInput/FJImageInputTwo';
import classNames from 'classnames';
import { UPLOAD_FILE_TYPE_IMAGE_EXTENDER } from '../../../../config/dataConfig/FJGenerateData';
import FJGenerateButtonContainer from '../../../FJObjectErase/FJObjectEraseLeft/container/FJGenerateButtonContainer';
import FJPhotoRemoveBgQuickSelectionBoxContainer from '../container/FJPhotoRemoveQuickSelectionBoxContainer';
import FJPhotoSettingBoxContainer from '../container/FJPhotoSettingBoxContainer';
import FJBrushCardTwoContainer from '../../../../common/components/FJBrushCard/FJBrushCardTwoContainer';
import FJBrushCardThreeContainer from '../../../../common/components/FJBrushCard/FJBrushCardThreeContainer';
import { USE_CREDIT } from '../../../../redux/slices/FJSlicePhotoBgRemover';
import FJConstant from '../../../../constants/FJConstant';
import FJLocalStore from '../../../../store/FJLocalStore';

const FJPhotoRemoveBgCustomLeft = props => {
    const {
        isShow,
        uploadCustomBgImage,
        isNotImage,
        isPhotoRemoveBg,
        freeNumCreation,
        brushEditStatus,
        openMediaLibrary,
    } = props;

    return (
        <div className={classNames(styles.custom_left, { [styles.show]: isShow })}>
            <FJImageInputTwo
                openMediaLibrary={openMediaLibrary}
                isSmallComponent={!isNotImage}
                uploadImg={uploadCustomBgImage}
                acceptFile={UPLOAD_FILE_TYPE_IMAGE_EXTENDER}
                disabled={brushEditStatus !== FJConstant.DEFAULT}
                isJudgeLogin={true}
            />

            {!isNotImage && (
                <>
                    {!isPhotoRemoveBg && (
                        <div className={styles.custom_left_bg}>
                            {FJLocalStore._('select-the-object-you-want-to-keep')}
                        </div>
                    )}
                    {!isPhotoRemoveBg && <FJPhotoRemoveBgQuickSelectionBoxContainer />}
                    {!isPhotoRemoveBg && <FJBrushCardTwoContainer className={styles.brush_container} />}
                    {isPhotoRemoveBg && <FJBrushCardThreeContainer />}
                    <FJPhotoSettingBoxContainer isShow={isPhotoRemoveBg} />
                </>
            )}

            {!isNotImage && !isPhotoRemoveBg && (
                <FJGenerateButtonContainer
                    text={'next'}
                    className={styles.generate_btn}
                    useCredit={USE_CREDIT}
                    customFreeNumCreation={freeNumCreation}
                />
            )}
        </div>
    );
};

FJPhotoRemoveBgCustomLeft.propTypes = {
    isShow: PropTypes.bool,
    uploadCustomBgImage: PropTypes.func,
    isNotImage: PropTypes.bool,
    isPhotoRemoveBg: PropTypes.bool,
    freeNumCreation: PropTypes.number,
    brushEditStatus: PropTypes.string,
    openMediaLibrary: PropTypes.func,
};

export default FJPhotoRemoveBgCustomLeft;
